import React, {Component} from 'react';
import {
    message
} from 'antd';
import PropTypes from 'prop-types';
import {
    BrowserRouter as Router,
    Switch,
    Redirect
} from 'react-router-dom';

import {LayoutWrapper} from '../../containers/Page';
import PrivateRoute from '../../containers/PrivateRoute';
import PublicRoute from '../../containers/PublicRoute';
import {
    Login,
    Confirm,
    Signup,
    Reset,
} from '../../containers/Pages';
import {
    Overview,
    Daily,
    Hourly,
    Clicks,
    SubID,
    Referer,
    Country,
} from '../../containers/Reports';
// import {
//   Quality,
// } from '../../containers/WhiteDiagnostic';
import {
    XML,
    Search,
} from '../../containers/Feeds';
import {
    History,
    Details,
} from '../../containers/Payments';
import {
    Opened,
    Closed,
} from '../../containers/Tickets';
import Profile from '../../containers/Profile';

import styles from './App.module.css';

message.config({
    top: 12,
    duration: 3
});

class App extends Component {
    componentDidUpdate(prevProps) {
        if (prevProps.isAuthenticated !== this.props.isAuthenticated) {
            this.props.isAuthenticated && this.success('You are logged in');
        }
    }

    success = (msg) => {
        message.success(msg);
    };

    render() {
        return (
            <Router basename="/publisher/">
                <div className={styles.app}>
                    <LayoutWrapper>
                        <Switch>
                            <PublicRoute restricted path="/login" component={Login}/>
                            <PublicRoute restricted path="/signup" component={Signup}/>
                            <PublicRoute restricted path="/confirm" component={Confirm}/>
                            <PublicRoute restricted path="/reset" component={Reset}/>
                            <PrivateRoute path="/reports/overview" component={Overview}/>
                            <PrivateRoute path="/reports/daily" component={Daily}/>
                            <PrivateRoute path="/reports/hourly" component={Hourly}/>
                            <PrivateRoute path="/reports/filtered_clicks" component={Clicks}/>
                            <PrivateRoute path="/reports/subid" component={SubID}/>
                            <PrivateRoute path="/reports/referer" component={Referer}/>
                            <PrivateRoute path="/reports/country" component={Country}/>
                            {/*<PrivateRoute path="/WD" component={Quality}/>*/}
                            <PrivateRoute path="/feeds/xml" component={XML}/>
                            <PrivateRoute path="/feeds/search" component={Search}/>
                            <PrivateRoute path="/payments/history" component={History}/>
                            <PrivateRoute path="/payments/details" component={Details}/>
                            <PrivateRoute path="/profile" component={Profile}/>
                            <PrivateRoute path="/tickets/opened" component={Opened}/>
                            <PrivateRoute path="/tickets/closed" component={Closed}/>
                            <Redirect to="/reports/overview"/>
                        </Switch>
                    </LayoutWrapper>
                </div>
            </Router>
        );
    }
}

App.propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
};

export default App;
